import React from 'react';
import * as Icons from "react-icons/fa";
import '../../components/styles.css';

export default function DigitalAgentTracking() {
    return (
      <div className='container-content-services'
        style={{
          backgroundColor:'gray',
          color:'black',
          border:'20px',
          padding:'20px',
		  	}}
		  >
        <div classNAme='main-content-box-1'  align='center'>
          <p-lg>Digital Agent Tracking  </p-lg>
        </div>
        <div className='main-content-box-2'  align='left'>
          <p> <br></br>
            Affiliates use unique tracking links to identify traffic and sales generated through their efforts. 
Standard digital tracking involves assigning each product a unique URL, provided by the merchant. 
Our program enhances this process by embedding additional information in the link, allowing for 
more detailed tracking of marketing campaign performance. When the link is clicked and a purchase 
is made, the merchant can trace the sale back to the specific affiliate, ensuring the sales agent 
receives the appropriate commission.
          </p>
        </div>
        <div className='main-content-box-3' align='center' >
              <p></p>
        </div>
      </div>
    )
  };

